import * as React from 'react';

interface Props {
    isParsed: boolean
}

export function ParsedBwicLabel({ isParsed }: Props) {
    return isParsed ? <span className="state-parsed">PARSED</span> : null;
}
